<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g fill="currentColor">
      <path
        stroke="#313132"
        stroke-width="1.25"
        d="M24 10.785l-9.375 7.125v29.465h18.75V17.91L24 10.785z"
        transform="translate(-257 -2336) translate(0 704) translate(0 1328) translate(15 88) translate(0 192) translate(242 24) translate(8 8)"
      />
      <path
        stroke="#313132"
        stroke-width="1.25"
        d="M27.375 36.625h-6.75v10.75h6.75v-10.75zM29.375 28.625h-10.75v2.75h10.75v-2.75zM44.375 30.625h-7.75v3.75h7.75v-3.75zM44.375 38.625h-7.75v3.75h7.75v-3.75zM11.375 30.625h-7.75v3.75h7.75v-3.75zM11.375 38.625h-7.75v3.75h7.75v-3.75z"
        transform="translate(-257 -2336) translate(0 704) translate(0 1328) translate(15 88) translate(0 192) translate(242 24) translate(8 8)"
      />
      <path
        stroke="#313132"
        stroke-width="1.25"
        d="M33.625 21.042v26.333h13.75v-19l-13.75-7.333zM14.375 21.042L.625 28.375v19h13.75V21.042z"
        transform="translate(-257 -2336) translate(0 704) translate(0 1328) translate(15 88) translate(0 192) translate(242 24) translate(8 8)"
      />
      <path
        fill="#313132"
        d="M24 0H25V11H24z"
        transform="translate(-257 -2336) translate(0 704) translate(0 1328) translate(15 88) translate(0 192) translate(242 24) translate(8 8)"
      />
    </g>
    <path
      fill="#FF7F7C"
      d="M32 24c1.657 0 3 1.25 3 2.793V33h-2.166v-2.483h-1.667V33H29v-6.207C29 25.25 30.343 24 32 24zm0 2.017c-.46 0-.833.348-.833.776v1.862h1.667v-1.862c0-.428-.374-.776-.834-.776zM44 8l-2.625 3L44 14H32V8h12z"
      transform="translate(-257 -2336) translate(0 704) translate(0 1328) translate(15 88) translate(0 192) translate(242 24)"
    />
  </svg>
</template>

<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
  name: 'IconGestionCentre'
})
</script>
